module.exports = __webpack_public_path__ + "img/mood_happy.976351fe.png";